import axios from '@axios'

// Все вкладки раздела читают данные из серверного снапшота (пересобирается раз в 2 часа);
// каждый ответ несёт cached_at — время актуальности данных, которое показывается в шапке.
const rememberCachedAt = (ctx, response) => {
  const cachedAt = response && response.data && response.data.cached_at
  if (cachedAt) ctx.commit('setCachedAt', cachedAt)
  return response
}

export default {
  namespaced: true,
  state: {
    cachedAt: null,
    isRefreshing: false,
    // Инкремент заставляет открытые вкладки перезапросить данные (после обновления снапшота)
    refreshVersion: 0,
  },
  getters: {},
  mutations: {
    setCachedAt(state, value) {
      state.cachedAt = value
    },
    setRefreshing(state, value) {
      state.isRefreshing = value
    },
    bumpRefreshVersion(state) {
      state.refreshVersion += 1
    },
  },
  actions: {
    fetchDashboard(ctx, params) {
      return axios
        .get('/finance/dashboard', { params })
        .then(response => rememberCachedAt(ctx, response))
    },
    fetchWeeks(ctx, params) {
      return axios
        .get('/finance/weeks', { params })
        .then(response => rememberCachedAt(ctx, response))
    },
    fetchWeek(ctx, weekId) {
      return axios.get(`/finance/weeks/${weekId}`)
    },
    fetchPayouts(ctx) {
      return axios
        .get('/finance/payouts')
        .then(response => rememberCachedAt(ctx, response))
    },
    fetchPacksRoi(ctx, params) {
      const normalized = { ...params }
      if (typeof normalized.include_archived === 'boolean') {
        normalized.include_archived = normalized.include_archived ? 1 : 0
      }
      return axios
        .get('/finance/packs/roi', { params: normalized })
        .then(response => rememberCachedAt(ctx, response))
    },
    fetchCacheStatus() {
      return axios.get('/finance/cache-status')
    },
    requestRefresh() {
      return axios.post('/finance/refresh')
    },
  },
}
